<template>
  <el-dialog
    :title="dateileData.poolName"
    :visible.sync="dialogVisi"
    width="40%"
    :before-close="handleClose"
  >
    <div class="common_readonly_template">
      <el-row>
        <el-col :span="24">
          <div>
            <div class="label">线索池ID</div>
            <div class="text">{{ dateileData.poolId }}</div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div class="label">线索池名称</div>
            <div class="text">{{ dateileData.poolName }}</div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div class="label">线索池管理员</div>
            <div class="text">
              <span v-for="(item, index) in dateileData.admins" :key="index">
                {{ item.adminName }}{{ index+1 == dateileData.admins.length?"":',' }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div class="label">创建时间</div>
            <div class="text">{{ dateileData.createTime?new Date(dateileData.createTime.replace(/-/g, '/')).format('yyyy-MM-dd'):'' }}</div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div class="label">分发规则</div>
            <div class="text">{{ dateileData.distributeType }}</div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div class="label">线索池所属部门</div>
            <div class="text">{{ dateileData.deptName }}</div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div class="label">线索数量</div>
            <div class="text">{{ dateileData.num }}</div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div class="label">最后一次修改时间</div>
            <div class="text">{{ dateileData.modifyTime?new Date(dateileData.modifyTime.replace(/-/g, '/')).format('yyyy-MM-dd'):'' }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisi: false
    };
  },
  watch: {
    showClueVis (val) {
      this.dialogVisi = val;
    },
    dateileData () {
      console.log(this.dateileData);
    }
  },
  props: {
    showClueVis: {
      type: Boolean,
      default: false
    },
    dateileData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    handleClose () {
      this.dialogVisi = false;
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
